export interface IApiResponse<T = any> {
  statusCode: number;
  error: boolean;
  message: string;
  data: T | null;
}

export interface IDeviceInfo {
  deviceId: string;
  deviceType: 'WEB' | 'ANDROID' | 'IOS';
  deviceName: string;
  lat: number | null;
  long: number | null;
}

export interface ILoginPayload {
  contact: string;
  country: string;
  deviceInfo: IDeviceInfo;
}

export enum ContactType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export interface IForgotPasswordRequestPayload {
  contact: string;
  country: 'NEPAL';
  contactType: ContactType.PHONE;
  deviceInfo: IDeviceInfo;
}

export interface IForgotPasswordVerifyPayload {
  otp: string;
  updatedPassword: string;
}

export interface ILoginData {
  isOtpSent?: boolean;
  contact?: string;
  passwordEnabled?: boolean;
  stateToken?: string;
}

export interface IWebDevice {
  deviceId: string;
  deviceName: string;
  location: string;
}

export interface IVerifyData {
  stateToken?: string;
  showSetRecovery?: boolean;
  showAskTrustedDevice?: boolean;
  showSecurityQuestions?: boolean;
  primaryDeviceId?: string;
  primaryDeviceName?: string;
  primaryDeviceLocation?: string;
  limitReached?: boolean;
  webDevices?: IWebDevice[];
  challenge?: string;
  isPushNotificationSent?: boolean;

  trustedDeviceId?: string;

  ssoSession?: string;

  [key: string]: any;
}

export type RecoveryField = 'PASSWORD' | 'EMAIL' | 'ALTERNATE_CONTACT_NUMBER';

export interface IRecoverySetupPayload {
  field: RecoveryField;
  fieldValue: string;
  confirmFieldValue?: string;
}

export interface IRecoverySetupVerifyPayload {
  field: RecoveryField;
  otp: string;
}

export interface IAddTrustedDevicePayload {
  fcmToken: string | null;
  publicKey: string;
  removeDeviceId?: string;
}

export interface IReviewApprovalPayload {
  approvalCode?: string;
  solvedCode: string;
}

export interface ICheckDeviceData {
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
  familyCode?: string;
  userId?: string;
  challenge?: string;
}

export interface ITrustedDeviceSolutionPayload {
  deviceId: string;
  solution: string;
}

export interface IAuthorizeSessionPayload {
  appId: number;
  codeChallenge: string;
}

export interface IAuthorizeSessionData {
  accessCode?: string;
  redirectUrl?: string;
}
